import clsx from 'clsx'
import { useState, type FC } from 'react'
import {
  FaUser,
  FaSignOutAlt,
  FaCheck,
  FaExchangeAlt,
  FaAngleUp,
  FaAngleDown
} from 'react-icons/fa'

import { ACTIONS } from '@/constants/common/message.constants'
import { type UserMeTenantExEntity, type UserMeExEntity } from '@/libs/api'

import { AuthUserPopoverListItem } from './AuthUserPopoverListItem'

type Props = {
  authUser: UserMeExEntity
  currentTenant: UserMeTenantExEntity
  onLogout: () => void
}

export const AuthUserPopover: FC<Props> = ({
  authUser,
  currentTenant,
  onLogout
}) => {
  const multipleTenants = authUser.tenants.length > 1
  const [tenantsCollapsed, setTenantsCollapsed] = useState(false)

  return (
    <div className="-m-3 min-w-[255px]">
      <div className="p-4">
        <div className="flex items-center gap-2.5">
          <div className="flex h-[38px] w-[38px] items-center justify-center rounded-md bg-gray-1 text-white">
            <FaUser className="text-xs" />
          </div>
          <div className="text-secondary">
            <div
              className="text-2xs"
              data-testid="auth-user-popover-current-tenant-name"
            >
              {currentTenant.name}
            </div>
            <div
              className="text-[13px]"
              data-testid="auth-user-popover-user-name"
            >
              {authUser.displayName}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col border-t border-t-gray-200">
        {multipleTenants && (
          <>
            <AuthUserPopoverListItem
              icon={<FaExchangeAlt />}
              suffix={tenantsCollapsed ? <FaAngleDown /> : <FaAngleUp />}
              onClick={() => setTenantsCollapsed((prev) => !prev)}
            >
              {ACTIONS.SWITCH_TENANT}
            </AuthUserPopoverListItem>
            <div
              className={clsx([
                'overflow-hidden',
                tenantsCollapsed ? 'h-0' : 'h-auto border-b'
              ])}
            >
              {authUser.tenants.map((tenant) => (
                <a key={tenant.key} href={`/${tenant.key}`}>
                  <AuthUserPopoverListItem
                    icon={
                      currentTenant.key === tenant.key ? (
                        <FaCheck className="text-primary" />
                      ) : undefined
                    }
                  >
                    {tenant.name}
                  </AuthUserPopoverListItem>
                </a>
              ))}
            </div>
          </>
        )}
        {/* 未対応のためコメントアウト */}
        {/* <Link to="/">
          <AuthUserPopoverListItem icon={<FaUserCog />}>
            ユーザー設定
          </AuthUserPopoverListItem>
        </Link> */}
        <AuthUserPopoverListItem
          icon={<FaSignOutAlt />}
          onClick={onLogout}
          data-testid="auth-user-popover-logout"
        >
          {ACTIONS.LOGOUT}
        </AuthUserPopoverListItem>
      </div>
    </div>
  )
}
